import React from "react";
import "./App.css";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { getAuthUser, isAuthenticated } from "./api/authApi";
import { getHomePath } from "./lib/roleAccess";

import Product from "./pages/product/productList";
import Category from "./pages/category/categoryList";

import Project from "./pages/project/project";

import AddProduct from "./pages/product/addProduct";
import EditProduct from "./pages/product/editProduct";
import ProductDetail from "./pages/product/productDetail";
import SubCategory from "./pages/subCategory/subCategoryList";
import Quotation from "./pages/quotation/quotation_list";
import AddQuotation from "./pages/quotation/addQuotation";
import QuotationDetail from "./pages/quotation/quotationDetail";
import EditQuotation from "./pages/quotation/editQuotation";
import InvoiceList from "./pages/invoice/invoice_list";

import InvoiceDetail from "./pages/invoice/invoiceDetail";
import EditInvoice from "./pages/invoice/editInvoice";
import Dashboard from "./pages/dashboard/dashboard";
import Login from "./pages/login/login";
import ProtectedRoute from "./commponents/ProtectedRoute";
import DeliveryOrder from "./pages/delivery_order/delivery_order_list";
import AddDeliveryOrder from "./pages/delivery_order/addDeliveryOrder";
import DetailDeliveryOrder from "./pages/delivery_order/deliveryOrderDetail";
import EditDeliveryOrder from "./pages/delivery_order/editDeliveryOrder";
import ProjectDetail from "./pages/project/projectDetail";
import SalesList from "./pages/sales/salesList";
import UserList from "./pages/user/UserList";
import UserDetail from "./pages/user/UserDetail";
import CustomerList from "./pages/customer/customerList";
import CustomerDetail from "./pages/customer/customerDetail";
import AddInvoice from "./pages/invoice/addInvoice";
import HomePageList from "./pages/homePage/homePageList";
import HomePageEdit from "./pages/homePage/homePageEdit";
import DosList from "./pages/dos/dosList";
import DosDetail from "./pages/dos/dosDetail";
import AddDos from "./pages/dos/addDos";
import EditDos from "./pages/dos/editDos";


function AppContent() {
  return (
    <main className="min-h-screen bg-[#ECECEC]">
      <Routes>
        {/* Root: kalau sudah login langsung ke halaman utama role-nya
            (Sales -> quotation, lainnya -> dashboard), kalau belum ke login */}
        <Route
          path="/"
          element={
            <Navigate
              to={isAuthenticated() ? getHomePath(getAuthUser()?.role) : "/login"}
              replace
            />
          }
        />

        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/product"
          element={
            <ProtectedRoute>
              <Product />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/add"
          element={
            <ProtectedRoute>
              <AddProduct />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/edit/:id"
          element={
            <ProtectedRoute>
              <EditProduct />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/detail/:id"
          element={
            <ProtectedRoute>
              <ProductDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/category"
          element={
            <ProtectedRoute>
              <Category />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subcategory"
          element={
            <ProtectedRoute>
              <SubCategory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project"
          element={
            <ProtectedRoute>
              <Project />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project/detail/:id"
          element={
            <ProtectedRoute>
              <ProjectDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/home-page"
          element={
            <ProtectedRoute>
              <HomePageList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/home-page/edit/:section"
          element={
            <ProtectedRoute>
              <HomePageEdit />
            </ProtectedRoute>
          }
        />

        <Route
          path="/quotation"
          element={
            <ProtectedRoute>
              <Quotation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quotation/add"
          element={
            <ProtectedRoute>
              <AddQuotation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quotation/detail/:id"
          element={
            <ProtectedRoute>
              <QuotationDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quotation/edit/:id"
          element={
            <ProtectedRoute>
              <EditQuotation />
            </ProtectedRoute>
          }
        />

        <Route
          path="/invoice"
          element={
            <ProtectedRoute>
              <InvoiceList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice/add"
          element={
            <ProtectedRoute>
              <AddInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice/add/:deliveryOrderId"
          element={
            <ProtectedRoute>
              <AddInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice/detail/:id"
          element={
            <ProtectedRoute>
              <InvoiceDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice/edit/:id"
          element={
            <ProtectedRoute>
              <EditInvoice />
            </ProtectedRoute>
          }
        />

        <Route
          path="/delivery_order/add/:quotationId"
          element={
            <ProtectedRoute>
              <AddDeliveryOrder />
            </ProtectedRoute>
          }
        />

        <Route
          path="/delivery_order"
          element={
            <ProtectedRoute>
              <DeliveryOrder />
            </ProtectedRoute>
          }
        />

        <Route
          path="/delivery_order/add"
          element={
            <ProtectedRoute>
              <AddDeliveryOrder />
            </ProtectedRoute>
          }
        />

        <Route
          path="/delivery_order/detail/:id"
          element={
            <ProtectedRoute>
              <DetailDeliveryOrder />
            </ProtectedRoute>
          }
        />

        <Route
          path="/delivery_order/edit/:id"
          element={
            <ProtectedRoute>
              <EditDeliveryOrder />
            </ProtectedRoute>
          }
        />

        {/* DOS: /dos/add dan /dos/edit hanya Sales (lihat lib/roleAccess.ts) */}
        <Route
          path="/dos"
          element={
            <ProtectedRoute>
              <DosList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dos/add"
          element={
            <ProtectedRoute>
              <AddDos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dos/edit/:id"
          element={
            <ProtectedRoute>
              <EditDos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dos/:id"
          element={
            <ProtectedRoute>
              <DosDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sales"
          element={
            <ProtectedRoute>
              <SalesList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/User"
          element={
            <ProtectedRoute>
              <UserList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/User/Detail/:id"
          element={
            <ProtectedRoute>
              <UserDetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Customer"
          element={
            <ProtectedRoute>
              <CustomerList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Customer/Detail/:id"
          element={
            <ProtectedRoute>
              <CustomerDetail />
            </ProtectedRoute>
          }
        />

        {/* Fallback: path tidak dikenal -> redirect ke root (yang akan
            redirect lagi ke login/dashboard sesuai status auth) */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
